import { useTranslation } from "react-i18next";

import { HookFormInput } from "@/components_v2/FormFields/ReactHookForm/fields";
import FormFieldWrapper from "@/components_v2/Wrapper/FormFieldWrapper";
import BaseButton from "@/components_v2/Button/BaseButton";
import { BUTTON_VARIANTS } from "@/components_v2/Button/constants";
import { OpenAccountStepProps } from "../types";

const OpenAccountStep = ({
  form,
  isSubmitting,
  handleBack,
  handleSubmit,
}: OpenAccountStepProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-400">
      <div className="flex flex-col gap-200">
        <h2 className="apply-to-join__title header-m-medium">
          {t("applications.labels.createAccountTitle")}
        </h2>
        <p className="apply-to-join__description body-m-regular">
          {t("applications.labels.openAccountDescription")}
        </p>
      </div>

      <div className="form-input-container text-start">
        <FormFieldWrapper label={t("applications.labels.email")} required>
          <HookFormInput name="email" control={form.control} disabled />
        </FormFieldWrapper>

        <div className="flex gap-200">
          <FormFieldWrapper label={t("applications.labels.firstName")} required>
            <HookFormInput
              name="firstName"
              placeholder={t("applications.placeholders.enterFirstName")}
              control={form.control}
            />
          </FormFieldWrapper>

          <FormFieldWrapper label={t("applications.labels.lastName")} required>
            <HookFormInput
              name="lastName"
              placeholder={t("applications.placeholders.enterLastName")}
              control={form.control}
            />
          </FormFieldWrapper>
        </div>

        <FormFieldWrapper label={t("auth.labels.password")} required>
          <HookFormInput
            type="password"
            name="password"
            control={form.control}
          />
        </FormFieldWrapper>

        <FormFieldWrapper label={t("auth.labels.confirmPassword")} required>
          <HookFormInput
            type="password"
            name="confirmPassword"
            control={form.control}
          />
        </FormFieldWrapper>
      </div>

      <div className="flex gap-300 full-width">
        <BaseButton
          variant={BUTTON_VARIANTS.TERTIARY}
          className="flex-1"
          onClick={handleBack}
        >
          {t("applications.labels.back")}
        </BaseButton>
        <BaseButton
          className="flex-1"
          loading={isSubmitting}
          onClick={handleSubmit}
        >
          {t("auth.labels.createAccount")}
        </BaseButton>
      </div>
    </div>
  );
};

export default OpenAccountStep;
